import UserRepository from './UserRepository'
import AgentRepository from './AgentRepository'
import ChatMessageRepository from './ChatMessageRepository'
import StatusRepository from './StatusRepository'
import PhonesRepository from './PhonesRepository'
import PhoneAccountRepository from './PhoneAccountRepository'
import TwilioRepository from './TwilioRepository'
import SettingMain from './SettingMain'
import AbsenceRepository from './AbsenceReponsitory'
import MonitoringRepository from './MonitoringRepository'
import StatisticRepository from './StatisticRepository'
import CompanyRepository from './CompanyRepository'
import LineRepository from './LineRepository'

const repositories = {
  users: UserRepository,
  agents: AgentRepository,
  chatMessage: ChatMessageRepository,
  status: StatusRepository,
  phones: PhonesRepository,
  phoneAccount: PhoneAccountRepository,
  twilio: TwilioRepository,
  settingMain: SettingMain,
  absence: AbsenceRepository,
  monitor: MonitoringRepository,
  statistic: StatisticRepository,
  company: CompanyRepository,
  line: LineRepository
}
export const RepositoryFactory = {
  get: (name) => repositories[name]
}
